import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = ({ onClose, formType }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    type: formType
  });
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    const submissionData = {
      access_key: '513f8aa0-886c-4aa5-beaa-c0403566af',
      from_name: formData.name,
      subject: `New ${formType} Inquiry`,
      message: `
        Name: ${formData.name}
        Email: ${formData.email}
        Type: ${formType}
        Message: ${formData.message}
      `,
      email_to: 'parityempowermentinitiative@outlook.com', // Add your email here
      reply_to: formData.email,
    };

    try {
      console.log('Submitting form data:', submissionData);
      
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(submissionData)
      });

      const data = await response.json();
      console.log('Response from Web3Forms:', data);

      if (data.success) {
        setStatus('success');
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        throw new Error(data.message || 'Submission failed');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus('error');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <h2>{formType}</h2>
      <div className="form-field">
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({...formData, name: e.target.value})}
          required
        />
      </div>
      <div className="form-field">
        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({...formData, email: e.target.value})}
          required
        />
      </div>
      <div className="form-field">
        <textarea
          placeholder="Your Message"
          value={formData.message}
          onChange={(e) => setFormData({...formData, message: e.target.value})}
          required
        ></textarea>
      </div>
      <button type="submit">Submit</button>
      {status === 'success' && <p className="success">Message sent successfully!</p>}
      {status === 'error' && <p className="error">Error sending message. Please try again.</p>}
    </form>
  );
};

export default ContactForm;
